export default {
  data() {
    return {
      loading: {
        display: false,
        message: "",
      },
    };
  },

  methods: {
    async load(data, message) {
      this.loading.message = message;
      this.loading.display = true;
      try {
        await data;
      } catch (err) {
        console.warn(err);
      }
      this.loading.display = false;
    },
  },
};
